import { createContext } from '@lit/context';

export const MobileContext = createContext<boolean>('is-mobile-context');
